import { render, staticRenderFns } from "./RecibosEsamLista.vue?vue&type=template&id=060d3ee8"
import script from "./RecibosEsamLista.vue?vue&type=script&lang=js"
export * from "./RecibosEsamLista.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports